// Speedy tracking operation codes (see operationCodes in the translation
// files) at which the buyer may still cancel: the courier has not handed
// anything over yet. Keep in sync with ShipmentCancelCodes.cs on the server,
// which stays the final authority.
//   0   - nothing recorded yet
//   148 - "Получени данни за пратката": Speedy received the shipment data
//         only; no parcel or courier movement
//   128 - "Отменено": already cancelled at Speedy, the buyer can still
//         finish the local cancel (stock restore, emails)
export const BUYER_CANCELLABLE_OPERATION_CODES = [0, 148, 128];

export const canBuyerCancel = (order: { isCancelled: boolean, operationCode: number }): boolean =>
  !order.isCancelled && BUYER_CANCELLABLE_OPERATION_CODES.includes(order.operationCode);

export type BuyerOrderStatus = 'processing' | 'onTheWay' | 'readyForPickup' | 'delivered' | 'cancelled';

// Speedy codes (see operationCodes in the translation files) -> what a buyer
// cares about. Codes not listed (failed delivery, returns, ...) return null
// and the caller falls back to Speedy's own label.
const ON_THE_WAY_CODES = [39, 1, 2, 12, 21, 175, 217];
const READY_FOR_PICKUP_CODES = [11, 134, 1134];
const DELIVERED_CODE = -14;

// A review is only offered once the parcel has actually been delivered
// (Speedy -14) and the order was not cancelled; before that the buyer has
// nothing to judge yet.
export const canBuyerReview = (order: { isCancelled: boolean, operationCode: number }): boolean =>
  !order.isCancelled && order.operationCode === DELIVERED_CODE;

export const getBuyerOrderStatus = (
  order: { isCancelled: boolean, operationCode: number }
): BuyerOrderStatus | null => {
  const { operationCode } = order;

  if (order.isCancelled || operationCode === 128) return 'cancelled';
  if (operationCode === 0 || operationCode === 148) return 'processing';
  if (operationCode === DELIVERED_CODE) return 'delivered';
  if (READY_FOR_PICKUP_CODES.includes(operationCode)) return 'readyForPickup';
  if (ON_THE_WAY_CODES.includes(operationCode)) return 'onTheWay';

  return null;
};
